import React, { useState, useEffect } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useDispatch, useSelector } from 'react-redux';
import { useLoader } from '../../common/component/LoaderProvider';
import { useForm } from 'react-hook-form'; 
import CommmonTable from '../../common/component/commonTable';
import {useToast} from '../../common/component/Toast'
import CommonLoader from "../../common/component/commonLoader";
import CommonButton from "../../common/component/commonButton";
import CommonOtpModal from "../../common/component/commonOtpModal";
import { AdminPPList,createAdminPP} from '../../service/action/actioncreator/AdminPPAction/AdminPP';
import { sendOtp} from '../../service/action/actioncreator/LoginAction/LoginAction';
import { useNavigate,useLocation  } from "react-router-dom";
import StepperModal from "../../common/component/commonStepper";
import {decryptUsingAES256, encryptUsingAES256} from '../../common/utils/index'
import {getPharmacy,getHospitalFacility } from '../../service/action/actioncreator/HospitalAction/Hospital';
import { useTranslation } from 'react-i18next';
import useValidation from '../../common/utils/validationRules';


const HospitalFacility=()=>{
    const [hospitalFacility,setHospitalfacility] =useState([])
    const [hospitalHeader,setHospitalHeader] =useState([])
    const [currentPageNumber,setCurrentPageNumber] =useState(1)
    const [isModalOpen, setIsModalOpen] =useState(false)
    const [progress, setProgress] = useState(33); 
    const [currentStep,setCurrentStep] =useState(1)
    const { showLoader, hideLoader } = useLoader();
    const itemsPerPage=10;
    const { showToast } = useToast();
    const { t } = useTranslation("translation");
    const { validateField } = useValidation();
  

    const dispatch = useDispatch();

    const { register, handleSubmit, formState: { errors }, setValue,getValues, control, reset,watch,trigger } = useForm(
        {mode:"onChange"}
      );

    useEffect(()=>{
      dispatch(getHospitalFacility(showLoader,hideLoader,showToast,t))
        
    },[])
    const hospitalFacilityDropdown=useSelector((state)=>state.hospitalReducer.hospitalFacilityResponse)
    const handlePreviousPage=(pageValue)=>{
        setCurrentPageNumber(pageValue)
      }
      const handleNextPage=(pageValue)=>{
        setCurrentPageNumber(pageValue)
      }
      useEffect(()=>{
        const data = hospitalFacilityDropdown?.result?.map(({ id, ...rest }) => rest);
        setHospitalfacility(hospitalFacilityDropdown?.result)
        let initialValue = data?.[0];
        let headerData = initialValue ? Object.keys(initialValue).map(item => item) : [];
        setHospitalHeader(headerData);
      },[hospitalFacilityDropdown,hospitalFacility])

     
  const totalPages = Math.ceil(hospitalFacilityDropdown?.totalCount / itemsPerPage);
  const stepConfigs = {

    3: [
      {
        title: "Step 1",
        titleMain:`structure`,
        textFooter:`structure`,
        fields: [
          { type: "heading", content: `${t("text_title_personal_data")}` },
          { name: "FirstName", type: "text", placeholder:`${t("text_name")}*`,validation:true},
          { name: "LastName",type: "text", placeholder:`${t("text_surname")}*`,validation:true},
          { name: "FiscalCode", type: "text", placeholder:`${t("text_taxId_code")}`,validation:false },
          { type: "heading", content: "Contatto",style:true },
          { name: "PhoneNumber", type: "phoneNumber", placeholder:`${t("text_telephone")}*`,validation:true},
          { type: "button",label:`${t("text_button_confirms")}`},
        ],
      },
      {
        title: "Step 2",
        titleMain:"Farmacia Ospedaliera di competenza",
        textFooter:"Individua e seleziona la struttura di competenza del supervisore",
        fields: [
          { type: "heading", content: "struttura" },
          { name: "hospitalPharamacyName", type: "dropdown", placeholder:`${t("text_pharmacy_name")}`,},
          { type: "buttonsRow" },
         
        ],
      },
      {
        title: "Step 3",
        titleMain:`${t("text_title_accounts_passwords")}`,
        textFooter:`${t("text_enter_account_passowrd_message")}`,
        fields: [
          { type: "heading", content:`${t("text_title_login")}` },
          { name: "UserEmail", type: "textStep2", placeholder:`${t("Email")}*`,validation:true},
          { name: "UserPassword", type: "textStep2", placeholder:`${t("text_temp_password")?.charAt(0).toUpperCase()+ t("text_temp_password")?.slice(1)}*`,validation:true},
          { name: "UserConfirmPassword", type: "textStep2", placeholder:`${t("placeholder_retype_password")}*`,validation:true},
          { type: "buttonRowEmail" },
         
        ],
      },
      {
        title: "Step 4",
        titleMain:`${t("text_title_summary")}`,
        textFooter:"Controlla l'esattezza dei dati inseriti per procedere",
        fields: [
          { type: "heading", content:`${t("text_new_administrator_data")}` },
          { type:"summary",content:'' },
          { type: "buttonsRow1" },
        ],
      },
    ],

   
  };

  const roleBasedSteps = stepConfigs[3];
  

    const handleRegister=()=>{
        setIsModalOpen(true);
        setCurrentStep(1);
        setProgress(33)
    }
    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleSubmitStep = () => {
    //    dispatch(createAdminPP(payload, showLoader, hideLoader, showToast,setIsSuccess));
      };

    return(
        <>
         <div className="d-flex justify-content-between">
          <h4 className="secondary-text-color fw-bold ms-4">{t("menu_hospitals")}</h4>
          <CommonButton icon={true} 
          label={`Nuovo ${t("menu_hospitals")}`}
          inputStyle={true}  className="btn btn-success padding-align input-style-common text-white me-3" type="button" variant="success" onClick={()=>handleRegister()} /> 
          </div>

           {hospitalFacility?.length > 0  ?
          <div className="mt-5 rounded-card">
          <CommmonTable
            dataContent={hospitalFacility}
            tableHeader={hospitalHeader}
             showEditButton={true}
             showDeleteButton={true}
            //  onEditData={handleEditData}
            //  onDeleteData={handleDeleteData}
             getValues={getValues}
             setValue={setValue}
             register={register}
             control={control}
             checkboxStatus={true}
             handlePreviousPage={handlePreviousPage}
             handleNextPage={handleNextPage}
             totalItems={hospitalFacilityDropdown?.totalCount}
             currentPage={currentPageNumber}
             totalPages={totalPages} 
         />

          </div>
          :
          <p className="text-center">
            No Data Found
          </p>
      }

        {isModalOpen && 
            <StepperModal
            isModalOpen={isModalOpen}
            handleModalClose={handleModalClose}
            currentStep={currentStep}
            progress={progress}
            // handleNext={handleNext}
            // handlePrevious={handlePrevious}
            getValues={getValues}
            // isSuccess={isSuccess}
            control={control}
            errors={errors}
            register={register}
            validateField={validateField}
            watch={watch}
            roleBasedSteps={roleBasedSteps}
            handleSubmitStep={handleSubmitStep}
            trigger={trigger}
            setProgress={setProgress}
            setCurrentStep={ setCurrentStep}
            mainTitle={"Hospital Facility"}
            progressHide={false}
          />
              }

        </>
    )
}
export default HospitalFacility;